type GoogleIconProps = {
  fill?: string;
  size?: number;
  useOriginalColors?: boolean;
};

function GoogleIconOriginal(props: GoogleIconProps) {
  const size = props.size ?? 12;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 1}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M22.3055 10.0415H21.5V10H12.5V14H18.1515C17.327 16.3285 15.1115 18 12.5 18C9.1865 18 6.5 15.3135 6.5 12C6.5 8.6865 9.1865 6 12.5 6C14.0295 6 15.421 6.577 16.4805 7.5195L19.309 4.691C17.523 3.0265 15.134 2 12.5 2C6.9775 2 2.5 6.4775 2.5 12C2.5 17.5225 6.9775 22 12.5 22C18.0225 22 22.5 17.5225 22.5 12C22.5 11.3295 22.431 10.675 22.3055 10.0415Z"
        fill="#FFC107"
      />
      <path
        d="M3.65283 7.3455L6.93833 9.755C7.82733 7.554 9.98033 6 12.4998 6C14.0293 6 15.4208 6.577 16.4803 7.5195L19.3088 4.691C17.5228 3.0265 15.1338 2 12.4998 2C8.65883 2 5.32783 4.1685 3.65283 7.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M12.5002 22.0003C15.0832 22.0003 17.4302 21.0118 19.2047 19.4043L16.1097 16.7853C15.1057 17.5458 13.8577 18.0003 12.5002 18.0003C9.89916 18.0003 7.69066 16.3418 6.85866 14.0273L3.59766 16.5398C5.25266 19.7783 8.61366 22.0003 12.5002 22.0003Z"
        fill="#4CAF50"
      />
      <path
        d="M22.3055 10.0415H21.5V10H12.5V14H18.1515C17.7555 15.1185 17.036 16.083 16.108 16.7855L16.1095 16.7845L19.2045 19.4035C18.9855 19.6025 22.5 17 22.5 12C22.5 11.3295 22.431 10.675 22.3055 10.0415Z"
        fill="#1976D2"
      />
    </svg>
  );
}

export function GoogleIcon(props: GoogleIconProps) {
  if (props.useOriginalColors) {
    return <GoogleIconOriginal {...props} />;
  }

  const fillColor = props.fill ?? 'var(--text-accent-high-contrast)';
  const size = props.size ?? 12;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="google-fill">
        <path
          id="Vector"
          d="M1.53182 3.75457C2.35455 2.12046 4.04542 1 6 1C7.3477 1 8.4795 1.49547 9.34545 2.30227L7.91135 3.73637C7.3932 3.24093 6.73405 2.98864 6 2.98864C4.69771 2.98864 3.59542 3.86819 3.20228 5.05C3.10225 5.35 3.04543 5.67045 3.04543 6C3.04543 6.32955 3.10225 6.65 3.20228 6.95C3.59542 8.1318 4.69771 9.01135 6 9.01135C6.6727 9.01135 7.24545 8.8341 7.6932 8.5341C8.2227 8.17955 8.575 7.65 8.6909 7.025H6V5.0909H10.7091C10.7682 5.41815 10.8 5.7591 10.8 6.11365C10.8 7.63635 10.2545 8.91815 9.30905 9.78865C8.4818 10.5523 7.35 11 6 11C4.04542 11 2.35455 9.87955 1.53182 8.24545C1.19319 7.57045 1 6.8068 1 6C1 5.1932 1.19319 4.42955 1.53182 3.75457Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
}
